import { render, staticRenderFns } from "./eventEnclosure.vue?vue&type=template&id=0a59b45f&scoped=true"
import script from "./eventEnclosure.vue?vue&type=script&lang=js"
export * from "./eventEnclosure.vue?vue&type=script&lang=js"
import style0 from "./eventEnclosure.vue?vue&type=style&index=0&id=0a59b45f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a59b45f",
  null
  
)

export default component.exports